export const AMPLIFY_USERNAME_ERROR = 'Username cannot be empty';
